import { combineReducers } from 'redux';
import authSlice from './authSlice';
import usersSlice from './usersSlice';
import appSlice from './appSlice';
import productsSlice from './productsSlice';
import clientsSlice from './clientsSlice';
import settingsSlice from './settingsSlice';
import themeSlice from './themeSlice';
import insuranceSlice from './insuranceSlice';
import statisticSlice from './statisticSlice';
import communicationSlice from './communicationSlice';
import faqSlice from './faqSlice';
import contactSlice from './contactSlice';
import privateIdUsersSlice from './privateIdUsersSlice';

export const rootReducer = combineReducers({
    app: appSlice,
    auth: authSlice,
    users: usersSlice,
    privateIdUsers: privateIdUsersSlice,
    products: productsSlice,
    clients: clientsSlice,
    settings: settingsSlice,
    insurance: insuranceSlice,
    themes: themeSlice,
    statistic: statisticSlice,
    communication: communicationSlice,
    faq: faqSlice,
    contact: contactSlice,
});
